/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_OpenInputs */

const th_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดการ`)
};

const en_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage`)
};

const ja_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const zh_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const es_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar`)
};

const pt_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar`)
};

const id_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola`)
};

const fr_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer`)
};

const tl_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamahalaan`)
};

const vi_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý`)
};

const ko_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관리`)
};

const de_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten`)
};

const ru_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управлять`)
};

const tr_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yönet`)
};

const it_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci`)
};

const pl_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj`)
};

const uk_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Керувати`)
};

const hi_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रबंधित करें`)
};

const ar_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة`)
};

const ms_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urus`)
};

const bn_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরিচালনা`)
};

const zh_tw2_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const zh_hk2_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const ur_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتظام`)
};

const fa_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدیریت`)
};

const sw_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simamia`)
};

const nl_org_open = /** @type {(inputs: Org_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheren`)
};

/**
* | output |
* | --- |
* | "Manage" |
*
* @param {Org_OpenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_open = /** @type {((inputs?: Org_OpenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_OpenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_open(inputs)
	if (locale === "ja") return ja_org_open(inputs)
	if (locale === "zh") return zh_org_open(inputs)
	if (locale === "es") return es_org_open(inputs)
	if (locale === "pt") return pt_org_open(inputs)
	if (locale === "id") return id_org_open(inputs)
	if (locale === "fr") return fr_org_open(inputs)
	if (locale === "tl") return tl_org_open(inputs)
	if (locale === "vi") return vi_org_open(inputs)
	if (locale === "ko") return ko_org_open(inputs)
	if (locale === "de") return de_org_open(inputs)
	if (locale === "ru") return ru_org_open(inputs)
	if (locale === "tr") return tr_org_open(inputs)
	if (locale === "it") return it_org_open(inputs)
	if (locale === "pl") return pl_org_open(inputs)
	if (locale === "uk") return uk_org_open(inputs)
	if (locale === "hi") return hi_org_open(inputs)
	if (locale === "ar") return ar_org_open(inputs)
	if (locale === "ms") return ms_org_open(inputs)
	if (locale === "bn") return bn_org_open(inputs)
	if (locale === "zh-TW") return zh_tw2_org_open(inputs)
	if (locale === "zh-HK") return zh_hk2_org_open(inputs)
	if (locale === "ur") return ur_org_open(inputs)
	if (locale === "fa") return fa_org_open(inputs)
	if (locale === "sw") return sw_org_open(inputs)
	if (locale === "nl") return nl_org_open(inputs)
	return en_org_open(inputs)
});